import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { RouteAreaService } from '../route-area.service';
import RouteAreaAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity';
import { LOCALIZED_PROPERTIES, ROUTE_AREA_EXPORT_ID, ROUTE_AREA_TITLE } from './route-area.constants';

@Injectable()
export class RouteAreaExport {
  constructor(
    private exportService: ExportService,
    private routeAreaService: RouteAreaService,
  ) {}

  private transformItem(item: RouteAreaAttributes) {
    return {
      name: get(item, 'name', '??'),
      company: get(item, 'company.name', '??'),
      statusId: this.getStatus(get(item, 'statusId', '')),
    };
  }

  private getStatus(value: string | number): string {
    if(!value && value !== 0) {
        return '';
    }
    return value === 1 ? 'Activo' : 'Inactivo';
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: ROUTE_AREA_EXPORT_ID,
      title: ROUTE_AREA_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(ROUTE_AREA_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.routeAreaService.findByFilter(buildQuery(
          seed(this.routeAreaService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(ROUTE_AREA_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(ROUTE_AREA_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
